export default [
  {
    name: 'English',
    code: 'en',
  },
  {
    name: 'Portuguese',
    code: 'pt',
  },
  {
    name: 'Spanish',
    code: 'es',
  },
];
